import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import { Link } from "gatsby"
import classNames from "classnames"
import * as moment from "moment"
import Human from "../icons/human"
import ArrowRightKey from "../icons/arrow-right-key"
import { formatName, formatDepartment } from "../../utils/str"
import styled from 'styled-components'

const styles = theme => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },

  rootBg: {
    padding: "22px 24px",
    height: "94px",
  },

  rootSm: {
    padding: "8px 10px",
    height: "64px",
  },

  icon: {
    minWidth: "48px",
    width: "48px",
    height: "48px",
    marginRight: "14px",
    background: "#F2F6F9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "24px",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    position: "relative",
    width: "calc(100% - 84px)",
  },

  header: {
    fontWeight: "bold",
    color: "#181819",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
  },

  headerBg: {
    fontSize: "16px",
    marginBottom: "7px",
  },

  headerSm: {
    fontSize: "13px",
    marginBottom: "5px",
  },

  desc: {
    color: "#71737B",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
  },

  descBg: {
    fontSize: "12px",
  },

  descSm: {
    fontSize: "11px",
  },

  headerBlock: {
    width: "35%",
    height: "16px",
    background: "#D8DBDF",
    marginBottom: "8px",
    borderRadius: "2px",
  },

  descBlock: {
    width: "90%",
    height: "12px",
    background: "#D8DBDF",
    borderRadius: "2px",
  },

  nameBlock: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    overflow: "hidden",
  },

  name: {
    minWidth: "50%",
    display: "flex",
    flex: 1,
  },

  labelContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginRight: "25px",
  },

  label: {
    color: "#5A5B62",
    background: "#F4F6F9",
    fontSize: "10px",
    padding: "4px 10px",
    whiteSpace: "nowrap",
    marginBottom: "7px",
    fontWeight: "bold",
    marginLeft: "5px",
  },
})

const KeymanItem = ({
  classes,
  item,
  short,
  small,
  showDepartment,
  showIndustry,
  showBorderBottom,
}) => {
  let size = small ? "Sm" : "Bg"

  if (!item) {
    return (
      <div
        className={classNames(classes.root, classes[`root${size}`])}
        style={{ pointerEvents: "none", borderBottom: showBorderBottom ? "1px solid #D8DBDF" : "" }}
      >
        <div className={classes.icon} style={{ background: "#F2F6F9" }}>
          <Human width={26} height={26} color={"#7C8297"} />
        </div>
        <div className={classes.container}>
          <div className={classes.headerBlock}></div>
          <div className={classes.descBlock}></div>
        </div>
      </div>
    )
  } else {
    return (
      <Link to={`/keymans/${item.id}`}>
        <Root className={classNames(classes.root, classes[`root${size}`])} style={{ borderBottom: showBorderBottom ? "1px solid #D8DBDF" : "" }} >
          <div className={classes.icon}>
            <Human width={26} height={26} color={"#7C8297"} />
          </div>
          <div className={classes.container}>
            <div className={classes.nameBlock}>
              <NameContainer className={classes.name}>
                <span className={classNames(classes.header, classes[`header${size}`])}>
                  {(short || small ? item.name : formatName(item)) + " 様"}
                </span>
              </NameContainer>
              <div className={classes.labelContainer}>
                {!short &&
                  !small &&
                  !!item.detail &&
                  showIndustry &&
                  item.detail.hasOwnProperty("jsic_l") && (
                    <div className={classes.label}>{item.detail.jsic_l}</div>
                  )}
                {!short && !small && showDepartment && (
                  <div className={classes.label}>
                    {formatDepartment(item.honorific)}
                  </div>
                )}
              </div>
            </div>
            <div className={classNames(classes.desc, classes[`desc${size}`])}>
              {short
                ? item.honorific
                : `${moment(item.relocation_at.date).format("YYYY年MM月")}に${
                    item.company_name
                  }の${item.honorific}に着任。`}
            </div>
          </div>
          <ArrowContainer>
            <ArrowRightKey
              height={24}
              width={24}
              color="#1866FF"
            />
          </ArrowContainer>
        </Root>
      </Link>
    )
  }
}

const Root = styled.div`
  &:hover {
    cursor: pointer;
    background: #EFF7FF;
  }
`;

const ArrowContainer = styled.div`
  & {
    display: none;
  }
  ${Root}:hover & {
    display: block;
  }
`;

const NameContainer = styled.div`
  & {
    text-decoration: unset;
    color: #000000;
  }
  ${Root}:hover & {
    text-decoration: underline;
  }
`;

KeymanItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  short: PropTypes.bool,
  small: PropTypes.bool,
  showDepartment: PropTypes.bool,
  showIndustry: PropTypes.bool,
  showBorderBottom: PropTypes.bool,
}

KeymanItem.defaultProps = {
  showDepartment: true,
  showIndustry: true,
  showBorderBottom: true,
}

export default withStyles(styles)(KeymanItem)
